import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    toastNotificationFeatureKey,
    ToastNotificationState,
} from './toast-notification.reducer';

export const selectToastNotificationFeature =
    createFeatureSelector<ToastNotificationState>(toastNotificationFeatureKey);

export const selectToastNotificationGroups = createSelector(
    selectToastNotificationFeature,
    (state) => state.groups,
);

export const selectToastNotificationExpanded = createSelector(
    selectToastNotificationFeature,
    (state) => state.expanded,
);

export const selectToastNotificationVisible = createSelector(
    selectToastNotificationGroups,
    (groups) => groups.length > 0,
);
